import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import firebase from 'firebase/app'

//import 'firebase/auth';        // for authentication
//import 'firebase/storage';     // for storage
//import 'firebase/database';    // for realtime database
import 'firebase/firestore'   // for cloud firestore
//import 'firebase/messaging';   // for cloud messaging
import 'firebase/functions'   // for cloud functions
import 'firebase/analytics'

import * as serviceWorker from './serviceWorker'

import { Layout } from './components/Layout'

import Guardians from './components/Guardians'
import Data from './components/Data'
import Guides from './components/Guides'
import Videos from './components/Videos'
import Home from './components/Home'

import './utility/CSS-Importer'


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSENGER_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics()

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const routes = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/guardians',
    component: Guardians,
  },
  {
    path: '/guardians/:id',
    component: Guardians
  },
  {
    path: '/data',
    component: Data
  },
  {
    path: '/guides',
    component: Guides
  },
  {
    path: '/videos',
    component: Videos
  }
];

const routeComponents = routes.map(({path, component}, key) => <Route exact path={path} component={component} key={key}/>);

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <Layout>
      <Switch>
      {routeComponents}
      <Redirect to='/' />
      </Switch>
    </Layout>
  </BrowserRouter>,
  rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
